/* VEGE ACTIVE SECTION */ 

function showText() {
	document.querySelector(".js-img-w-text__text").classList.toggle('show');
	document.querySelector(".img-w-text__btn").classList.toggle('show');
}

/* STICKY BUY BUTTON */ 

if($(window).width()<750){
    $("#sticky-product-parent").addClass("js-sticky-product-parent");
} 
else {
    $("#sticky-product-parent").removeClass("js-sticky-product-parent");
}
// this is used whenever the window is resized
$(window).resize(function(){
  if($(window).width()<750){
        $("#sticky-product-parent").addClass("js-sticky-product-parent");
    } 
    else {
        $("#sticky-product-parent").removeClass("js-sticky-product-parent");
    }
});

$(document).scroll(function() {
	var y = $(this).scrollTop();
	if (y > 550) {
		$('.js-sticky-product-parent').fadeIn();
	} else {
		$('.js-sticky-product-parent').fadeOut();
	}
});

/* STICKY CART FOOTER */ 
// if($(window).width()<751){
//   $("#main-cart-footer").addClass("js-sticky-footer-parent");
// } 
// else {
//   $("#main-cart-footer").removeClass("js-sticky-footer-parent");
// }
// // this is used whenever the window is resized
// $(window).resize(function(){
// if($(window).width()<751){
//       $("#main-cart-footer").addClass("js-sticky-footer-parent");
//   } 
//   else {
//       $("#main-cart-footer").removeClass("js-sticky-footer-parent");
//   }
// });

// $(document).scroll(function() {
// var y = $(this).scrollTop();
// if (y > 50) {
//   $('.js-sticky-footer-parent').fadeIn();
// } else {
//   $('.js-sticky-footer-parent').fadeOut();
// }
// });

/* STICKY CART FOOTER BUTTON */ 

function seeMore() {
  var buttonArea = document.getElementById( 'js-button-area' );
  if (
     buttonArea.classList.contains( 'open' ) 
   ) {
     //shrink the box
     buttonArea.classList.remove( "open" );      
   }
  else {
     //Expand the box
     buttonArea.classList.add( "open" );      
 }
}



/* VARIANT SELECT */

jQuery(function() {
	$('.single-option-selector').on('change', function(){
			setTimeout(function(){ 
				if($('[name="id"]').val() != "{{ product.selected_or_first_available_variant.id }}"){
					location.reload();
				}
			}, 1);
	});
});


/* SHOW PASSWORD */

function showPassword() {
  var passwordFields = document.querySelectorAll('input[type="password"]');

  var eyeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.335 8.865">
  <defs>
    <style>
      .cls-1 {
        fill: #563e29;
      }
    </style>
  </defs>
  <g id="eye" transform="translate(-229.665 -427)">
    <g id="eye-2" data-name="eye">
      <g id="picto_eye" data-name="picto eye" transform="translate(229.714 427)">
        <path id="Tracé_517" data-name="Tracé 517" class="cls-1" d="M18.21,4.237A11.409,11.409,0,0,0,9.166,0H9.1A11.423,11.423,0,0,0,.023,4.237a.3.3,0,0,0,0,.391A11.458,11.458,0,0,0,9.117,8.865h.065a11.469,11.469,0,0,0,9.045-4.221A.342.342,0,0,0,18.21,4.237Zm-5.3.2A3.773,3.773,0,0,1,9.345,8.2H9.117A3.773,3.773,0,0,1,9.133.652h.228A3.785,3.785,0,0,1,12.914,4.433Zm-12.222,0A10.384,10.384,0,0,1,6.379.978a4.421,4.421,0,0,0,0,6.91A10.574,10.574,0,0,1,.691,4.433ZM11.936,7.871a4.452,4.452,0,0,0,1.646-3.439A4.4,4.4,0,0,0,11.936.994a10.33,10.33,0,0,1,5.606,3.439A10.425,10.425,0,0,1,11.936,7.871Z" transform="translate(0)"/>
        <path id="Tracé_518" data-name="Tracé 518" class="cls-1" d="M43.3,16.235A2.135,2.135,0,1,0,45.435,14.1,2.142,2.142,0,0,0,43.3,16.235Zm3.6,0a1.483,1.483,0,1,1-1.483-1.483A1.488,1.488,0,0,1,46.9,16.235Z" transform="translate(-36.285 -11.802)"/>
      </g>
    </g>
  </g>
</svg>`;

  var noEyeIcon = `<?xml version="1.0" encoding="utf-8"?>
  <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 18.3 15" style="enable-background:new 0 0 18.3 15;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:none;stroke:#563E29;stroke-width:0.7;stroke-linecap:round;}
    .st1{fill:#563E29;}
  </style>
  <line id="Ligne_59" class="st0" x1="2.2" y1="14.5" x2="16.2" y2="0.5"/>
  <g id="eye" transform="translate(409 49)">
    <g id="picto_eye" transform="translate(229.714 427)">
      <path id="Tracé_517" class="st1" d="M-620.5-468.8c-2.2-2.7-5.5-4.3-9-4.2h-0.1c-3.5-0.1-6.9,1.5-9.1,4.2c-0.1,0.1-0.1,0.3,0,0.4
        c2.2,2.7,5.6,4.3,9.1,4.2h0.1c3.5,0,6.8-1.5,9-4.2C-620.4-468.5-620.4-468.7-620.5-468.8z M-625.8-468.6c0,2-1.6,3.7-3.6,3.8h-0.2
        c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8h0.2C-627.3-472.2-625.7-470.6-625.8-468.6L-625.8-468.6z M-638-468.6
        c1.5-1.7,3.5-3,5.7-3.5c-1.9,1.5-2.2,4.3-0.7,6.2c0.2,0.3,0.4,0.5,0.7,0.7C-634.5-465.6-636.5-466.8-638-468.6L-638-468.6z
         M-626.7-465.1c1-0.8,1.6-2.1,1.6-3.4c0-1.3-0.6-2.6-1.6-3.4c2.2,0.5,4.2,1.7,5.6,3.4C-622.6-466.9-624.5-465.6-626.7-465.1z"/>
      <path id="Tracé_518" class="st1" d="M-631.6-468.6c0,1.2,1,2.1,2.1,2.1c1.2,0,2.1-1,2.1-2.1c0-1.2-1-2.1-2.1-2.1
        C-630.7-470.7-631.6-469.7-631.6-468.6z M-628-468.6c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5
        C-628.7-470.1-628.1-469.4-628-468.6z"/>
    </g>
  </g>
  </svg>
`;

  Array.from(passwordFields).forEach((input) => {
    var a = document.createElement("a");
    a.innerHTML = eyeIcon;
    a.classList.add("password-image");
    a.onclick = function () {
      if (input.type === "password") {
        input.type = "text";
        a.innerHTML = noEyeIcon;
      } else {
        input.type = "password";
        a.innerHTML = eyeIcon;
      }
      input.focus();
    }
    a.herf = "javascript:void(0);"; 

    input.parentElement.appendChild(a);
  });

}


/* LOGIN  Terms & Conditions checkbox */
 
function loginCheck() {

	if($('#agree').is(':checked') == true){
		$('#js-login-btn').removeClass('disabled');
		$(this).submit();
	}
	else if($('#agree').is(':checked') == false){ 
		$('#js-login-btn').addClass('disabled');
		return false;
	}
};

// CONTACT FORM VALIDATION

$(document).ready(() => {
  $("input.js-contact-validation[type=text]").change(onContactFormUpdate);
  $("input.js-contact-validation[type=tel]").change(onContactFormUpdate);
  $("input.js-contact-validation[type=email]").change(onContactFormUpdate);
  $("textarea.js-contact-validation").change(onContactFormUpdate);
  var $contact = $('#js-contact-btn');
  $contact.attr('disabled', true);
})

function onContactFormUpdate() {
  const contactName = $("#ContactForm-name").val();
  const contactEmail = $("#ContactForm-email").val();
  const contactPhone = $("#ContactForm-phone").val();
  const contactMessage = $("#ContactForm-body").val();
  var $input = $('.js-contact-validation');

  $input.on("keyup change",function ()  {
    $input.each(function() {
        if (!$(this).val()) {
            this.classList.remove("valid");
        }
        else {
          this.classList.add("valid");
        }
    });
  });


  if (contactName && contactEmail && contactPhone && contactMessage) {
    $("#js-contact-btn").removeAttr("disabled");
  } else {
    $("#js-contact-btn").attr("disabled", "disabled");
  }
}

// LOADING BUTTON
function loadingButtonForm(selector, loading=true){
    loading ? $(selector).addClass('loading') : $(selector).removeClass('loading');
    $(selector).prop('disabled', loading);
}


// CHECKING QUANTITTY INPUT
function int(value) {
  return parseInt(value);
}
function checkValue(sender) {
  let min = sender.min;
  let max = sender.max;
  let value = int(sender.value);
  if (value>max) {
      sender.value = max;
  } else if (value<min) {
      sender.value = min;
  }
}


// EMAIL MARKETING CONFIRMATION PAGE 

$(document).ready(function(){
  $('div.shopify-email-marketing-confirmation__container').addClass('shopify-email-marketing-confirmation__container--custom');
})